(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cable-estimator"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var form = root.querySelector('[data-cable-form]');
      var roomRows = root.querySelector('[data-room-rows]');
      var deviceRows = root.querySelector('[data-device-rows]');
      var roomTemplate = root.querySelector('[data-room-template]');
      var deviceTemplate = root.querySelector('[data-device-template]');
      var output = root.querySelector('[data-cable-output]');
      var errorBox = root.querySelector('[data-cable-error]');
      var productStatus = root.querySelector('[data-product-status]');
      var addAllButton = root.querySelector('[data-add-all]');
      var i18n = JSON.parse(root.querySelector('[data-cable-i18n]').textContent);
      var collectionHandle = root.dataset.collectionHandle;
      var locale = root.dataset.locale || 'en';
      var currency = root.dataset.currency || 'EGP';
      var state = { products: [], recommendations: [], loaded: false };
      var rootPath = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
      var emptyText = root.querySelector('.cable-estimator__empty p').textContent;
      var devicePowerSettings = {
        ac: { label: i18n.horsepower, unit: i18n.hp, min: .5, max: 10, step: .5, defaultValue: 1.5 },
        electricHeater: { label: i18n.devicePower, unit: i18n.kw, min: .5, max: 15, step: .5, defaultValue: 3 },
        instantHeater: { label: i18n.devicePower, unit: i18n.kw, min: 1, max: 30, step: .5, defaultValue: 7 },
        washingMachine: { label: i18n.devicePower, unit: i18n.kw, min: .1, max: 10, step: .1, defaultValue: 2 },
        fridge: { label: i18n.devicePower, unit: i18n.kw, min: .1, max: 5, step: .1, defaultValue: .5 },
        stove: { label: i18n.devicePower, unit: i18n.kw, min: 1, max: 30, step: .5, defaultValue: 7 }
      };

      function escapeHtml(value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function formatMoney(value) {
        try {
          return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(Number(value));
        } catch (error) {
          return Number(value).toFixed(2) + ' ' + currency;
        }
      }

      function firstNumber(value) {
        var number = Number.parseFloat(value);
        return Number.isFinite(number) ? number : 0;
      }

      function parseGauge(title) {
        var match = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*(?:mm2|mm²|mm)/i);
        return match ? Number(match[1].replace(',', '.')) : null;
      }

      function imageUrl(product) {
        if (product.images && product.images.length) {
          return typeof product.images[0] === 'string' ? product.images[0] : product.images[0].src;
        }
        return product.image && product.image.src ? product.image.src : '';
      }

      function loadProducts() {
        var products = [];
        var page = 1;

        function next() {
          var url = '/collections/' + encodeURIComponent(collectionHandle) + '/products.json?limit=250&page=' + page;
          return fetch(url, { headers: { Accept: 'application/json' } })
            .then(function (response) {
              if (!response.ok) throw new Error('Collection request failed');
              return response.json();
            })
            .then(function (data) {
              var batch = Array.isArray(data.products) ? data.products : [];
              products = products.concat(batch);
              if (batch.length === 250 && page < 10) {
                page += 1;
                return next();
              }
              state.products = products
                .filter(function (product) {
                  return String(product.vendor || '').toLowerCase() === 'el sewedy electric' &&
                    String(product.title || '').toLowerCase().indexOf('stranded copper wire') !== -1;
                })
                .map(function (product) {
                  product.gauge = parseGauge(product.title);
                  return product;
                });
              state.loaded = true;
              root.querySelector('.cable-estimator__results').setAttribute('aria-busy', 'false');
              productStatus.textContent = i18n.productsReady.replace('__COUNT__', state.products.length);
              productStatus.classList.add('is-ready');
            });
        }

        return next().catch(function () {
          state.loaded = false;
          root.querySelector('.cable-estimator__results').setAttribute('aria-busy', 'false');
          productStatus.textContent = i18n.productsUnavailable;
        });
      }

      function cloneTemplate(template, destination) {
        var fragment = template.content.cloneNode(true);
        destination.appendChild(fragment);
        updateRemoveButtons();
        updateDevicePowerFields();
      }

      function updateRemoveButtons() {
        var rooms = roomRows.querySelectorAll('[data-room-row]');
        var devices = deviceRows.querySelectorAll('[data-device-row]');
        rooms.forEach(function (row) {
          row.querySelector('[data-remove-row]').hidden = rooms.length === 1;
        });
        devices.forEach(function (row) {
          row.querySelector('[data-remove-row]').hidden = devices.length === 1;
        });
      }

      function updateDevicePowerFields() {
        deviceRows.querySelectorAll('[data-device-row]').forEach(function (row) {
          var type = row.querySelector('[data-device-type]').value;
          var settings = devicePowerSettings[type] || devicePowerSettings.ac;
          var input = row.querySelector('[data-device-power]');
          var previousType = row.dataset.powerType;

          row.querySelector('[data-power-label]').textContent = settings.label;
          row.querySelector('[data-power-unit]').textContent = settings.unit;
          input.min = settings.min;
          input.max = settings.max;
          input.step = settings.step;
          if ((previousType && previousType !== type) || !input.value) input.value = settings.defaultValue;
          row.dataset.powerType = type;
        });
      }

      root.addEventListener('click', function (event) {
        var removeButton = event.target.closest('[data-remove-row]');
        if (removeButton) {
          removeButton.closest('[data-room-row], [data-device-row]').remove();
          updateRemoveButtons();
          return;
        }

        if (event.target.closest('[data-add-room]')) {
          cloneTemplate(roomTemplate, roomRows);
          return;
        }

        if (event.target.closest('[data-add-device]')) {
          cloneTemplate(deviceTemplate, deviceRows);
        }
      });

      root.addEventListener('change', function (event) {
        if (event.target.matches('[data-device-type]')) updateDevicePowerFields();
      });

      function collectRooms(area) {
        var rooms = [];
        var rows = roomRows.querySelectorAll('[data-room-row]');
        for (var index = 0; index < rows.length; index += 1) {
          var row = rows[index];
          var width = firstNumber(row.querySelector('[name="roomWidth[]"]').value);
          var length = firstNumber(row.querySelector('[name="roomLength[]"]').value);
          if (width < 1 || width > 30 || length < 1 || length > 30) throw new Error(i18n.invalidRoom);
          if (width * length > area) throw new Error(i18n.roomExceedsArea);
          rooms.push({
            type: row.querySelector('[name="roomType[]"]').value,
            width: width,
            length: length,
            area: width * length,
            perimeter: 2 * (width + length)
          });
        }
        return rooms;
      }

      function collectDevices() {
        var devices = [];
        deviceRows.querySelectorAll('[data-device-row]').forEach(function (row) {
          var type = row.querySelector('[name="deviceType[]"]').value;
          var settings = devicePowerSettings[type] || devicePowerSettings.ac;
          var quantity = Math.max(0, Math.min(20, Math.round(firstNumber(row.querySelector('[name="deviceQuantity[]"]').value))));
          var power = firstNumber(row.querySelector('[name="devicePower[]"]').value);
          if (!quantity) return;
          if (power < settings.min || power > settings.max) throw new Error(i18n.invalidDevicePower);
          devices.push({ type: type, quantity: quantity, power: power });
        });
        return devices;
      }

      function addLength(result, gauge, routeMeters, source) {
        var key = String(gauge);
        if (!result[key]) result[key] = { gauge: gauge, routeMeters: 0, sources: [] };
        result[key].routeMeters += routeMeters;
        if (result[key].sources.indexOf(source) === -1) result[key].sources.push(source);
      }

      function cableGaugeForKilowatts(kilowatts) {
        if (kilowatts <= 2.5) return 2.5;
        if (kilowatts <= 4) return 4;
        if (kilowatts <= 7.5) return 6;
        if (kilowatts <= 11) return 10;
        if (kilowatts <= 18) return 16;
        return 25;
      }

      function calculate(area, rooms, devices) {
        var result = {};
        var diagonal = Math.sqrt(area);

        rooms.forEach(function (room) {
          var lightPoints = Math.max(1, Math.ceil(room.area / 12));
          var lightingRoute = room.perimeter + 6 + lightPoints * 3;
          addLength(result, 1.5, lightingRoute, 'lighting');

          var socketFactor = 1;
          if (room.type === 'kitchen') socketFactor = 1.55;
          if (room.type === 'bathroom' || room.type === 'guestToilet') socketFactor = .7;
          if (room.type === 'entrance' || room.type === 'terraceBalcony' || room.type === 'dressing') socketFactor = .6;
          addLength(result, 2.5, (room.perimeter * 1.15 + 8) * socketFactor, 'sockets');
        });

        addLength(result, 1.5, area * .2, 'lighting');
        addLength(result, 2.5, area * .28, 'sockets');

        devices.forEach(function (device) {
          var route = Math.max(14, diagonal * 1.45) * device.quantity;
          var gauge = 2.5;
          var source = 'appliances';

          if (device.type === 'ac') {
            source = 'airConditioning';
            gauge = cableGaugeForKilowatts(device.power * 1.1);
          } else {
            gauge = cableGaugeForKilowatts(device.power);
          }

          addLength(result, gauge, route, source);
        });

        var feederGauge = area <= 90 ? 6 : area <= 180 ? 10 : 16;
        addLength(result, feederGauge, Math.max(16, diagonal * 1.5), 'mainFeeder');

        return Object.keys(result).map(function (key) {
          var item = result[key];
          item.designMeters = item.routeMeters * 1.15;
          item.rollsPerConductor = Math.max(1, Math.ceil(item.designMeters / 100));
          item.totalRolls = item.rollsPerConductor * 3;
          return item;
        }).sort(function (a, b) {
          return a.gauge - b.gauge;
        });
      }

      function productForGauge(gauge) {
        return state.products.find(function (product) {
          return product.gauge === gauge;
        });
      }

      function findVariant(product, purpose) {
        var variants = Array.isArray(product.variants) ? product.variants : [];
        var available = variants.filter(function (variant) { return variant.available; });
        if (available.length === 1) return available[0];

        var patterns = purpose === 'phase'
          ? [/black/i, /red/i]
          : purpose === 'neutral'
            ? [/blue/i]
            : [/yellow\s*\/\s*green/i, /earth/i, /^green$/i];

        for (var index = 0; index < patterns.length; index += 1) {
          var match = available.find(function (variant) {
            return patterns[index].test(String(variant.title || ''));
          });
          if (match) return match;
        }
        return null;
      }

      function cartPlan(product, recommendation) {
        var variants = Array.isArray(product.variants) ? product.variants : [];
        if (variants.length === 1) {
          return variants[0].available ? [{
            id: variants[0].id,
            quantity: recommendation.totalRolls,
            purpose: i18n.recommendedMix
          }] : [];
        }

        return ['phase', 'neutral', 'earth'].map(function (purpose) {
          var variant = findVariant(product, purpose);
          return variant ? {
            id: variant.id,
            quantity: recommendation.rollsPerConductor,
            purpose: i18n[purpose] + ': ' + variant.title
          } : null;
        }).filter(Boolean);
      }

      function mergeCartItems(plans) {
        var merged = {};
        plans.forEach(function (item) {
          var key = String(item.id);
          if (!merged[key]) merged[key] = { id: item.id, quantity: 0 };
          merged[key].quantity += item.quantity;
        });
        return Object.keys(merged).map(function (key) { return merged[key]; });
      }

      function renderProduct(recommendation) {
        var product = productForGauge(recommendation.gauge);
        var sourceText = recommendation.sources.map(function (source) { return i18n[source]; }).join(', ');
        if (!product) {
          return '<div class="cable-estimator__missing"><strong>' +
            escapeHtml(recommendation.gauge + ' mm²') +
            '</strong><br>' + escapeHtml(i18n.missingProduct) +
            ' <a href="' + escapeHtml(rootPath + 'collections/' + collectionHandle) + '">' +
            escapeHtml(i18n.viewCables) + '</a></div>';
        }

        var plan = cartPlan(product, recommendation);
        var price = product.variants && product.variants.length ? product.variants[0].price : 0;
        var image = imageUrl(product);
        var productUrl = rootPath + 'products/' + product.handle;
        var mix = plan.length
          ? plan.map(function (item) {
              return '<span>' + escapeHtml(item.quantity + ' ' + item.purpose) + '</span>';
            }).join('')
          : '<span>' + escapeHtml(i18n.unavailable) + '</span>';

        return '<article class="cable-estimator__product">' +
          '<a class="cable-estimator__product-image" href="' + escapeHtml(productUrl) + '">' +
            (image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(product.title) + '" width="160" height="160" loading="lazy">' : '') +
          '</a>' +
          '<div>' +
            '<p class="cable-estimator__gauge">' + escapeHtml(recommendation.gauge + ' mm²') + '</p>' +
            '<h3>' + escapeHtml(product.title) + '</h3>' +
            '<p class="cable-estimator__product-meta">' +
              escapeHtml(Math.round(recommendation.designMeters) + ' ' + i18n.metersEstimated + ' | ' + sourceText) +
            '</p>' +
            '<div class="cable-estimator__mix">' + mix + '</div>' +
          '</div>' +
          '<div class="cable-estimator__product-footer">' +
            '<span class="cable-estimator__price">' + escapeHtml(formatMoney(price)) + '</span>' +
            '<div class="cable-estimator__product-actions">' +
              '<a class="cable-estimator__button cable-estimator__button--quiet" href="' + escapeHtml(productUrl) + '">' + escapeHtml(i18n.viewProduct) + '</a>' +
              '<button class="cable-estimator__button cable-estimator__button--primary" type="button" data-add-product="' + escapeHtml(String(recommendation.gauge)) + '"' + (plan.length ? '' : ' disabled') + '>' +
                escapeHtml(i18n.addProduct.replace('__COUNT__', recommendation.totalRolls)) +
              '</button>' +
            '</div>' +
          '</div>' +
        '</article>';
      }

      function render(recommendations) {
        state.recommendations = recommendations;
        var total = recommendations.reduce(function (sum, item) { return sum + item.totalRolls; }, 0);
        output.innerHTML =
          '<div class="cable-estimator__summary"><span>' + escapeHtml(i18n.recommendedTotal) + '</span><strong>' +
          escapeHtml(total + ' ' + (total === 1 ? i18n.roll : i18n.rolls)) +
          '</strong></div>' +
          recommendations.map(renderProduct).join('');
        addAllButton.hidden = recommendations.every(function (item) {
          var product = productForGauge(item.gauge);
          return !product || cartPlan(product, item).length === 0;
        });
      }

      function showError(message) {
        errorBox.textContent = message;
        errorBox.hidden = false;
        errorBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }

      function clearError() {
        errorBox.textContent = '';
        errorBox.hidden = true;
      }

      function addItems(items, button) {
        if (!items.length) return Promise.resolve();
        var original = button.textContent;
        button.disabled = true;
        button.textContent = i18n.adding;
        return fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: mergeCartItems(items) })
        }).then(function (response) {
          if (!response.ok) throw new Error(i18n.cartError);
          button.textContent = i18n.added;
          window.location.href = rootPath + 'cart';
        }).catch(function (error) {
          button.disabled = false;
          button.textContent = original;
          showError(error.message || i18n.cartError);
        });
      }

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        clearError();
        try {
          var area = firstNumber(form.elements.apartmentArea.value);
          if (area < 40 || area > 300) throw new Error(i18n.invalidArea);
          var rooms = collectRooms(area);
          var devices = collectDevices();
          render(calculate(area, rooms, devices));
          root.querySelector('.cable-estimator__results').scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (error) {
          showError(error.message);
        }
      });

      form.addEventListener('reset', function () {
        window.setTimeout(function () {
          while (roomRows.children.length > 1) roomRows.lastElementChild.remove();
          while (deviceRows.children.length > 1) deviceRows.lastElementChild.remove();
          updateRemoveButtons();
          updateDevicePowerFields();
          clearError();
          state.recommendations = [];
          addAllButton.hidden = true;
          output.innerHTML = '<div class="cable-estimator__empty"><span class="cable-estimator__empty-icon" aria-hidden="true">mm²</span><p>' +
            escapeHtml(emptyText) +
            '</p></div>';
        }, 0);
      });

      output.addEventListener('click', function (event) {
        var button = event.target.closest('[data-add-product]');
        if (!button) return;
        var gauge = firstNumber(button.dataset.addProduct);
        var recommendation = state.recommendations.find(function (item) { return item.gauge === gauge; });
        var product = recommendation ? productForGauge(gauge) : null;
        if (product && recommendation) addItems(cartPlan(product, recommendation), button);
      });

      addAllButton.addEventListener('click', function () {
        var items = [];
        state.recommendations.forEach(function (recommendation) {
          var product = productForGauge(recommendation.gauge);
          if (product) items = items.concat(cartPlan(product, recommendation));
        });
        addItems(items, addAllButton);
      });

      updateRemoveButtons();
      updateDevicePowerFields();
      loadProducts();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-cable-estimator]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spark-seller-page"] && !Shopify.designMode) return;
  try {
    
(function generateParticles() {
      const root = document.querySelector('.spark-seller-page');
      if (!root) return;
      const container = root.querySelector('#heroParticles');
      if (!container) return;
      const count = 40;
      for (let i = 0; i < count; i++) {
        const p = document.createElement('div');
        p.classList.add('particle');
        p.style.left = Math.random() * 100 + '%';
        p.style.animationDuration = (4 + Math.random() * 8) + 's';
        p.style.animationDelay = (Math.random() * 6) + 's';
        p.style.width = p.style.height = (2 + Math.random() * 3) + 'px';
        if (Math.random() > 0.5) p.style.background = '#7B68EE';
        container.appendChild(p);
      }
    })();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const delay = parseInt(entry.target.dataset.delay || 0);
          setTimeout(() => {
            entry.target.classList.add('revealed');
          }, delay);

          const counter = entry.target.querySelector('[data-count]');
          if (counter && !counter.dataset.animated) {
            counter.dataset.animated = 'true';
            animateCounter(counter);
          }

          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

    document.querySelectorAll('.spark-seller-page .stat-card, .spark-seller-page .benefit-card, .spark-seller-page .process-step, .spark-seller-page .feature-card, .spark-seller-page .faq-item').forEach(el => {
      observer.observe(el);
    });

    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.querySelectorAll('[data-count]').forEach(counter => {
            if (!counter.dataset.animated) {
              counter.dataset.animated = 'true';
              animateCounter(counter);
            }
          });
          heroObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    document.querySelectorAll('.spark-seller-page .hero-visual-stats').forEach(el => heroObserver.observe(el));

    function animateCounter(el) {
      const target = parseInt(el.dataset.count);
      const duration = 2000;
      const start = performance.now();
      const isPercent = el.closest('.stat-card')?.querySelector('.stat-label')?.textContent.includes('%') ||
                        el.closest('.hero-mini-stat')?.querySelector('.hero-mini-stat-label')?.textContent.includes('%');

      function update(now) {
        const progress = Math.min((now - start) / duration, 1);
        const eased = 1 - Math.pow(1 - progress, 3);
        const current = Math.floor(eased * target);

        if (target >= 1000) {
          el.textContent = current.toLocaleString() + '+';
        } else if (isPercent) {
          el.textContent = current + '%';
        } else {
          el.textContent = current + '+';
        }

        if (progress < 1) requestAnimationFrame(update);
      }

      requestAnimationFrame(update);
    }

    let currentStep = 1;

    window.nextStep = function(step) {
      const currentPanel = document.getElementById('panel' + currentStep);
      const requiredFields = currentPanel.querySelectorAll('[required]');
      let valid = true;

      requiredFields.forEach(field => {
        if (!field.value.trim()) {
          field.style.borderColor = '#ff4444';
          field.addEventListener('input', () => { field.style.borderColor = ''; }, { once: true });
          valid = false;
        }
      });

      if (!valid) return;

      currentPanel.classList.remove('active');
      document.getElementById('panel' + step).classList.add('active');

      document.getElementById('dot' + currentStep).classList.remove('active');
      document.getElementById('dot' + currentStep).classList.add('completed');
      document.getElementById('dot' + currentStep).textContent = '✓';
      document.getElementById('dot' + step).classList.add('active');

      if (currentStep < step) {
        document.getElementById('line' + currentStep).classList.add('filled');
      }

      currentStep = step;
      document.querySelector('.form-card').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    window.prevStep = function(step) {
      document.getElementById('panel' + currentStep).classList.remove('active');
      document.getElementById('panel' + step).classList.add('active');

      document.getElementById('dot' + currentStep).classList.remove('active');
      document.getElementById('dot' + step).classList.remove('completed');
      document.getElementById('dot' + step).classList.add('active');
      document.getElementById('dot' + step).textContent = step;

      document.getElementById('line' + step).classList.remove('filled');

      currentStep = step;
    }

    const sellerForm = document.getElementById('sellerForm');
    if (sellerForm) {
      sellerForm.addEventListener('submit', function(e) {
      
      });
    }

    window.toggleFaq = function(el) {
      const item = el.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.spark-seller-page .faq-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    }

    document.querySelectorAll('.spark-seller-page a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

  } catch(e) { console.error(e); }
})();
})();
